export default {
  unavailable: {
    title: 'Klantfacturen zijn niet beschikbaar',
    description:
      'Gasten die bij uw restaurants bestellen, kunnen geen factuur aanvragen, dus hier hoeft niets te worden ingesteld. Bestelbewijzen en de facturen die uw provider aan u uitgeeft, worden niet beïnvloed.',
  },
};
